require("!!/home/runner/replbox-1/node_modules/script-loader/addScript.js")(require("!!/home/runner/replbox-1/node_modules/raw-loader/index.js!/home/runner/replbox-1/node_modules/biwascheme/src/system/_types.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./node_modules/biwascheme/src/system/_types.js
// module id = 40
// module chunks = 0